import React from 'react'

import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class SaisieLibreMultipleBool extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={!this.props.disabled &&<button type="button" onClick={this.props.onClickSaisieLibreMultipleBool}
                                                       disabled={this.props.disabled || false}
                                                       className="text-success ei-commun_ajouter"
                                                       style={{display: 'inline-block', marginLeft: 5}}/>}>

        {
          (this.props.data !== undefined ? this.props.data : []).map((data, index) => (

            <Grid key={index} container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => this.props.onClickBoolSaisieLibreMultipleBool(index)}
                        disabled={this.props.disabled || false}
                        className={'ei-commun_pouce ei-' + (data.valeur_bool === true || data.valeur_bool === 1 || parseInt(data.valeur_bool) === 1 ? 'up primaryColor' : 'down secondaryColor')}/>
              </Grid>
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Traduction style={this.props.style}
                  onChange={(e) => this.props.onChangeSaisieLibeMultipleBool(e, index)}
                  name={'text'}
                  disabled={this.props.disabled || false}
                  data={data.text !== undefined ? data.text : []}
                  type={Constants.typeSaisie.SaisieLibre}
                />
              </Grid>
              <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => this.props.onClickRemoveSaisieLibreMultipleBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={this.props.disabled || false}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/SaisieLibre/SaisieLibreMultipleBool.js